import { render, staticRenderFns } from "./AddWebsite.vue?vue&type=template&id=b151294a&"
import script from "./AddWebsite.vue?vue&type=script&lang=js&"
export * from "./AddWebsite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports